export type Environment = "production" | "staging" | "local";

export function getEnvironment(): Environment {
  if (typeof window === "undefined") return "production";
  const host = window.location.hostname;
  if (host === "itspip.hillsdale.edu") return "production";
  if (host === "itspip.hillsdale.dev") return "staging";
  return "local";
}

export function isNonProduction(env: Environment = getEnvironment()): boolean {
  return env !== "production";
}
